import { Component, OnDestroy, OnInit } from '@angular/core';
import { ListItemRendererComponent } from 'gung-list';
import { JeevesDeliveryLocation } from 'gung-standard-jeeves';
import { HlDisplayModalService } from '../../services/hl-display-modal.service';
import { HlDisplayDeliveryAddressesListConfigService } from '../../services/hl-display-delivery-addresses-list-config.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-hl-display-customer-pod-list-table-view',
  templateUrl: './hl-display-customer-pod-list-table-view.component.html',
  styleUrl: './hl-display-customer-pod-list-table-view.component.css',
  standalone: false
})
export class HlDisplayCustomerPodListTableViewComponent extends ListItemRendererComponent<JeevesDeliveryLocation[]> implements OnInit, OnDestroy {
  protected unsubscribe: Subject<void> = new Subject<void>();
  protected selectedCustomerId: string;

  constructor(
    protected hlDisplayModalService: HlDisplayModalService,
    protected hlDisplayDeliveryAddressesListConfigService: HlDisplayDeliveryAddressesListConfigService
  ) {
    super();
  }

  ngOnInit(): void {
    this.hlDisplayDeliveryAddressesListConfigService.customerSubject.pipe(takeUntil(this.unsubscribe)).subscribe(customer => {
      this.selectedCustomerId = customer.id;
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public openEditPOD(deliveryLocation: JeevesDeliveryLocation): void {
    this.hlDisplayModalService.openAddEditHlDisplayDeliveryLocation(this.selectedCustomerId, deliveryLocation).then(
      () => { },
      () => { }
    );
  }
}
